import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import api from '../../../services/API';
import { useParams } from 'react-router-dom';
import './styles.css';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ModalItensPontuacao from '../ModalItensPontuacao';
import ModalMidia from '../ModalMidia';
import moment from 'moment-timezone';
import capitalize from '../../../utils/capitalize';

export default function DetalheParceiro() {
  const [buscando, setBuscando] = useState(false);
  const [buscandoPontuacoes, setBuscandoPontuacoes] = useState(false);
  const { cpf } = useParams();
  const [parceiro, setParceiro] = useState([]);
  const [pontuacoes, setPontuacoes] = useState([]);
  const [mostrarModalItens, setMostrarModalItens] = useState(false);
  const [produtos, setProdutos] = useState([]);
  const [mostrarModalFoto, setMostrarModalFoto] = useState(false);
  const [arquivo, setArquivo] = useState([]);
  const [tipo, setTipo] = useState('');

  useEffect(() => {
    buscarParceiro();
    buscarPontuacoes();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const buscarPontuacoes = async () => {
    setBuscandoPontuacoes(true);
    const filtros = {
      cpf,
    };
    const pontuacoes = await api.get(
      `/api/pontuacoes?filtros=${JSON.stringify(filtros)}`
    );
    if (pontuacoes.data) {
      setPontuacoes(pontuacoes.data.pontuacoes);
    }
    setBuscandoPontuacoes(false);
  };

  const buscarParceiro = async () => {
    setBuscando(true);
    const filtros = {
      cpf,
    };
    const resultado = await api.get(
      `/api/parceiros/painel?filtros=${JSON.stringify(filtros)}`
    );
    if (resultado) {
      const parceiro = resultado.data.parceiros[0];

      let cpf = parceiro.cpf.replace(/[^\d]/g, '');
      parceiro.cpf = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');

      if (parceiro.dataNascimento) {
        parceiro.dataNascimento = moment(parceiro.dataNascimento).format(
          'DD/MM/YYYY'
        );
      } else {
        parceiro.dataNascimento = '';
      }

      parceiro.celular = parceiro.celular ? `(${parceiro.celular.substring(
        0,
        2
      )}) ${parceiro.celular.substring(2, 7)}-${parceiro.celular.substring(7)}` : '-';

      parceiro.aceitouRegulamento = parceiro.aceitouRegulamento ? 'Sim' : 'Não';

      parceiro.endCep = parceiro.endCep ? `${parceiro.endCep.substring(
        0,
        5
      )}-${parceiro.endCep.substring(5)}` : '-';

      parceiro.endereco = parceiro.endRua ? (parceiro.endComplemento
        ? `${parceiro.endRua}, ${parceiro.endNumero}<br/>${parceiro.endBairro} - ${parceiro.endComplemento}<br/>${parceiro.endCidade} - ${parceiro.endEstado}`
        : `${parceiro.endRua}, ${parceiro.endNumero}<br/>${parceiro.endBairro}<br/>${parceiro.endCidade} - ${parceiro.endEstado}`) : '-';

      setParceiro(parceiro);
      setBuscando(false);
    }
  };

  const visualizarModalItens = (produtos) => {
    setProdutos(produtos);
    setMostrarModalItens(true);
  };

  const fecharModalItens = () => {
    setMostrarModalItens(false);
  };

  const visualizarModalFoto = (dirFoto) => {
    if (dirFoto.endsWith('.pdf')) {
      window.open(dirFoto);
    } else {
      setArquivo(dirFoto);
      setMostrarModalFoto(true);
      setTipo('image');
    }
  };

  const fecharModalFoto = () => {
    setMostrarModalFoto(false);
  };

  const columns = [
    {
      text: 'Venda',
      dataField: 'identificador',
    },
    {
      text: 'Pontos',
      dataField: 'totalPontos',
      formatter: (celula, valor) => {
        return Number(valor.totalPontos).toLocaleString('pt-BR');
      },
    },
    {
      text: 'Data da Venda',
      dataField: 'realizadoEm',
      formatter: (celula, valor) => {
        return moment(valor.realizadoEm).format('DD/MM/YYYY HH:mm:ss');
      },
    },
    {
      text: 'Data da Pontuação',
      dataField: 'pontuadoEm',
      formatter: (celula, valor) => {
        return moment(valor.pontuadoEm).format('DD/MM/YYYY HH:mm:ss');
      },
      sort: true,
    },
    {
      text: 'Validade dos Pontos',
      dataField: 'venceEm',
      formatter: (celula, valor) => {
        return moment(valor.venceEm).format('DD/MM/YYYY HH:mm:ss');
      },
    },
    {
      text: 'Itens da Venda',
      dataField: 'itens',
      formatter: (celula, valor) => {
        return (
          <button
            className="btn-limpo f-12 p-1"
            onClick={() => visualizarModalItens(valor.itens)}
          >
            <i className="fas fa-list"></i>
          </button>
        );
      },
    },
    {
      text: 'Foto da Venda',
      dataField: 'dirFoto',
      formatter: (celula, valor) => {
        if (valor.diretorioArquivo) {
          const url = valor.diretorioArquivo;
          return (
            <button
              className="btn-limpo f-12 p-1"
              onClick={() => {
                if (valor.diretorioArquivo.endsWith('.pdf')) {
                  window.open(url);
                } else {
                  visualizarModalFoto(url);
                }
              }}
            >
              <i className="fas fa-image"></i>
            </button>
          );
        } else {
          return (
            <button className="btn-limpo f-12 p-1" disabled>
              SEM FOTO
            </button>
          );
        }
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: 'pontuadoEm',
      order: 'desc',
    },
  ];

  return (
    <Container fluid>
      <h4 className="pt-3 pb-3 f-black">{capitalize(parceiro.nome)}</h4>
      <hr className="hr-loja mt-0 mb-4" />
      <Row>
        <Col md={6} lg={3} className="mb-2">
          <div className="card-detalhe p-3">
            <span>
              <b>CPF</b>
            </span>
            <span>{parceiro.cpf}</span>
            <br />
            <span>
              <b>Data de Nascimento</b>
            </span>
            <span>{parceiro.dataNascimento}</span>
          </div>
        </Col>
        <Col md={6} lg={3} className="mb-2">
          <div className="card-detalhe p-3">
            <span>
              <b>Celular</b>
            </span>
            <span>{parceiro.celular}</span>
            <br />
            <span>
              <b>Email </b>
            </span>
            <span>{parceiro.email}</span>
          </div>
        </Col>
        <Col md={6} lg={3} className="mb-2">
          <div className="card-detalhe p-3">
            <span>
              <b>Aceitou Regulamento</b>
            </span>
            <span>{parceiro.aceitouRegulamento}</span>
          </div>
        </Col>
        <Col md={6} lg={3} className="mb-2">
          <div className="card-detalhe p-3">
            <span>
              <b>Endereço</b>
            </span>
            <span
              dangerouslySetInnerHTML={{ __html: parceiro.endereco }}
            ></span>
            <br />
            <span>
              <b>CEP</b>
            </span>
            <span>{parceiro.endCep}</span>
          </div>
        </Col>
      </Row>
      <h4 className="pt-3 pb-3 f-black">Vendas</h4>
      <hr className="hr-loja mt-0 mb-4" />
      <div>
        <BootstrapTable
          bootstrap4
          noDataIndication={() =>
            buscandoPontuacoes ? (
              <span>
                Carregando
                <i className="fas fa-circle-notch fa-spin ml-3"></i>
              </span>
            ) : (
              <span>Sem resultados</span>
            )
          }
          classes="table-dark text-center rounded"
          wrapperClasses="rounded"
          bordered={false}
          keyField="id"
          data={pontuacoes}
          columns={columns}
          pagination={paginationFactory()}
          defaultSorted={defaultSorted}
        />
      </div>
      <ModalItensPontuacao
        show={mostrarModalItens}
        onHide={fecharModalItens}
        produtos={produtos}
      />
      <ModalMidia
        show={mostrarModalFoto}
        onHide={fecharModalFoto}
        arquivo={arquivo}
        tipo={tipo}
      />
    </Container>
  );
}
